import { render } from "./ChevronLeft.svg?vue&type=template&id=bdf9e746"
const script = {}
script.render = render

export default script